import React,{useState,useEffect} from 'react';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import BottomButtons from './BottomButtons';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Theme} from './Theme';
import {Dataset} from './Inc';
import useStyles from './Styles';

interface MailsRemainingProps {
	isOpen:boolean,
	value:number,
    update(value:number):void,
    close(): void,
}

const MailsRemaining: React.FC<MailsRemainingProps> = (props)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
	const [states,setStates] = useState({
		remaining: 0,
	});
	const changeRemaining = (event: SelectChangeEvent) => {
		const remaining = parseInt(event.target.value);
		setStates({...states,remaining:remaining});
    };	
	const update = ()=>{
		props.update(states.remaining);
	}

	useEffect(()=>{
		if( props.isOpen ){
			setStates({...states,remaining:props.value});
		}
	},[props.isOpen]);

	if(!props.isOpen){
		return (null);
	}

	const remainings:Dataset[] = [];
	for( let i=1; i<21; i++ ){
		remainings.push({
			id: String(i),
			label: String(i)+'個以下',
		});
	}

	return (
		<Dialog
			fullScreen={fullScreen}
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}			
		>
			<DialogTitle color='primary'>在庫僅少のお知らせ・個数の設定</DialogTitle>
			<DialogContent dividers>
				<div className={classes.confirmGuide}>
					在庫僅少のお知らせの基準となる個数を設定して下さい。<br/>
					<div className={classes.hintList}>
					※指定した数より在庫が少なくなったら翌日の午前7時頃に通知します<br/>
					※完売のお知らせと重複する場合は通知されません<br/>
					</div>
				</div>
				<FormControl fullWidth={true}>
                <Select
                    value={String(states.remaining)}
                    onChange={changeRemaining}
                    inputProps={{
                        name: 'remaining',
                        id: 'remaining',
                    }}
                    margin="none"
					variant="standard"
                    style={{marginTop:"0.3em"}}
                >
                    {remainings.map((option:Dataset,index:number) => {
						const key = "option"+index;
						return (
							<MenuItem key={key} value={option.id}>
								{option.label}
							</MenuItem>
						)
					})}
                </Select>					
				</FormControl>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='設定する' onClick1={update} button2='やめる' onClick2={props.close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
	);
}

export default MailsRemaining;
